import { createLocaleProvider as e } from "@systemeio/util";
//#region src/i18n/context.tsx
var { LocaleContext: t, LocaleProvider: n } = e();
//#endregion
export { t as LocaleContext, n as LocaleProvider };
